import { useTranslation } from 'react-i18next';

const NAMESPACE = 'translation';
const KEY_PREFIX = 'views.documents_templates_edit';

export default function useEditorTranslation() {
  return useTranslation(NAMESPACE, {
    keyPrefix: KEY_PREFIX,
  });
}
